import type { PersonalLoanCalculationCriteria } from '@hyphengroup/cms-components/calculatedAttributes/collect';
import type { LoanFieldsRank } from './types';

/**
 * Blocks whose loan fields illustrate the loan the editor entered, so the
 * reader's filter never moves them (CMS-1921 R1, CMS-1928 R5).
 */
const STATEMENT_BLOCKS = new Set([
  'ComponentPagesComponentTableBuilderComponent',
  'ComponentPagesComponentQuickAnswerComponent',
]);

/**
 * The one place that decides what a module's own loan fields mean (CMS-1890).
 *
 * A block reports its fields as facts; whether they freeze the module or merely
 * start it off is policy, and policy can depend on anything the page knows —
 * block type today, vertical or brand tomorrow — so it lives here and not in
 * the block.
 */
export const rankLoanFields = (
  component: { __typename?: string } | undefined,
  criteria: PersonalLoanCalculationCriteria,
): LoanFieldsRank =>
  STATEMENT_BLOCKS.has(component?.__typename ?? '') && criteria.loanFields
    ? 'statement'
    : 'default';
